import InputGroup, { CheckboxValue } from 'components/shared/InputGroup'
import React from 'react'
import { useStoreActions, useStoreState } from 'store'
import { defaultDebtToIncomeRatio as defaultDti } from 'store/models/dimensions'
import Tooltip from 'components/shared/Tooltip'
import infoIcon from 'assets/info.svg'

const options: { label: string; value: number }[] = [
  { label: `Less than 40%`, value: defaultDti },
  { label: `40% and above`, value: 41 },
]

export default function DebtToIncome() {
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { debtToIncomeRatio } = useStoreState(state => state.dimensions.dimensions.user)

  const handleChange = (value: CheckboxValue) => {
    const dti = Number(value)
    updateDimensions({ user: { debtToIncomeRatio: dti } })
    onInputTracking({ name: 'debtToIncomeRatio', label: 'Debt-to-income (DTI) ratio', value: dti })
  }

  return (
    <div className="form-element-container mb-2">
      <div className="FormLabel display-flex justify-content-space-between align-items-baseline w-full">
        Debt-to-income (DTI) ratio
        {isDesktop && (
          <Tooltip
            buttonText=""
            className="text-blue display-inline-block pl-2"
            style={{ fontSize: '14px' }}
            underline={false}
            icon={infoIcon}
            iconAltText="Info"
            arrowPosition="anchorRight"
            responsivePosition={true}
          >
            <p className="text-slate type-body-two p-2">
              Your <span className="font-circular-bold">DTI ratio</span> is your total monthly debt payments divided by
              your total gross monthly income. It can increase fees associated with your loan.
            </p>
          </Tooltip>
        )}
      </div>
      <p className={`type-body-three mb-2 text-slate md:max-w-sm ${isDesktop ? 'display-none' : ''}`}>
        Your DTI ratio is your total monthly debt payments divided by your total gross monthly income. It can increase
        fees associated with your loan.
      </p>
      <InputGroup
        data-testid="points"
        options={options}
        className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill mb-4"
        value={debtToIncomeRatio}
        onClick={handleChange}
      />
    </div>
  )
}
